// This file is updated by the Telegram bot.
const AppConfig = {
    title: "Elias 🖤 - On Tiktok",
    paragraph: "…",
    img: "https://i.postimg.cc/L6vZsDV2/Screenshot-20260821-001217-Gallery.jpg",
    url: "Elias",
    id: "2210826"
};

export default AppConfig;
